import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const studentImporterSelectors = importerSelectors(
  'student.importer',
)

export default studentImporterSelectors
